import { render, staticRenderFns } from "./CookieDeclaration.vue?vue&type=template&id=56a1f850&"
import script from "./CookieDeclaration.vue?vue&type=script&lang=js&"
export * from "./CookieDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports